import ProductBrief from './ProductBrief.jsx';

export {Product, ProductBrief}



// WEBPACK FOOTER //
// ./components/partials/product/index.js